import Lokka from 'lokka'
import Transport from 'lokka-transport-http'

function getCsrfToken() {
  const meta = document.querySelector('meta[name="csrf-token"]')
  return meta ? meta.getAttribute('content') : ''
}

function buildClient() {
  const hostname = window.location.origin

  if (On.Store.state.page.hostname == hostname) {
    let locale = On.Store.state.page.locale
    locale = locale ? `/${locale}` : ''

    const graphqlUrl = `${hostname}${locale}/graphql`
    const client = new Lokka({
      transport: new Transport(graphqlUrl, {
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-TOKEN': getCsrfToken(),
        },
      }),
    })
    return client
  } else {
    return { query: () => new Promise(() => {}) }
  }
}

window.On.API = window.On.API || {}
window.On.API.buildClient = buildClient

export default buildClient
